// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"4ad24ec9","787":"8c2c2bea"}[chunkId] + ".chunk.js";
};